import React, { useEffect, useState } from 'react';
import Accordion from '../Accordion';
import './mleMakerChecker.scss';
import OwnershipDetailsView from './OwnershipDetailsView';
import MleCheckerApprovalForm from './MleCheckerApprovalForm';
import UboDetailsAccordion from './UboDetailAccordian';
import { convertArrayToObject, filterSectionCheckerData } from './mleMakerChecker.utils';
import { MAKER_CHECKER_EVENT_TYPES_MLE } from 'utils/constants/commonValues';

const OwnershipDetailsAccordion = ({ data, additionalData, auth, isViewMode }) => {


    const [checkerRemarksData, setCheckerRemarksData] = useState({
      uboDeclarationUrls: [],
        'uboDetails.0': [],
    });
    const [transformedData, setTransformedData] = useState({});

    const checkerData = filterSectionCheckerData(additionalData?.childCheckerResponseList, MAKER_CHECKER_EVENT_TYPES_MLE.ubo);
    const editedFields = checkerData?.editedFields || null;
    

    const handleCheckerRemarksData = (section, updatedData) => {
        
        setCheckerRemarksData(prevState => ({
                ...prevState,
                [section]: updatedData,
        }));
    };
    useEffect(() => {
        let transformedData = convertArrayToObject(checkerData?.checkerRemarks[0])
        setTransformedData(transformedData);
    }, []);

    const checkerLevel = additionalData?.childCheckerResponseList?.[0]?.approvalLevel || null;
    

    const levelMapping = {
        L1: 'L2',
        L2: 'L3',
        L3: null, 
    };
    const raisedToLevel = levelMapping[checkerLevel] || null;
    

    
    let requestCheckerData = checkerRemarksData;
    if (Object.keys(requestCheckerData).length === 0) {
        requestCheckerData = transformedData;
    }
    return (
        <div className="ownership-details-accordion">
            {
                !!data?.uboDeclarationUrls && (
                    <Accordion
                        id="uboDeclarations"
                        key={`uboDeclartions`}
                        customClass="rounded-accordion"
                        upperComponent={<h3>{`UBO Declaration Urls`}</h3>}
                        isOpened
                        isArrowIndicator
                        lowerComponent={
                            <OwnershipDetailsView
                                data={data.uboDeclarationUrls}
                                section="uboDeclarationUrls"
                                additionalData={transformedData?.uboDeclarationUrls}
                                auth={auth}
                                handleCheckerRemarksData={handleCheckerRemarksData}
                                isViewMode={isViewMode}
                                editedFields={editedFields}
                            />
                        }
                    />
                )
            }
            <UboDetailsAccordion
            transformedData={transformedData} 
            data={data}
            auth={auth}
            handleCheckerRemarksData={handleCheckerRemarksData}
            isViewMode={isViewMode}
            editedFields={editedFields}
            />

            <MleCheckerApprovalForm
                raisedToLevel={raisedToLevel}
                requestDetails={{
                    eventType:
                        checkerData?.eventType?.toUpperCase() ||
                        '',
                    makerRequestId:
                        checkerData
                            ?.makerRequestId || '',
                    status: additionalData?.status,
                    remarks: checkerData?.remarks || null
                }}
                checkerRemarks={requestCheckerData}
                auth={auth}
                isViewMode={isViewMode}
                parentEventType = {additionalData?.eventType}
            />
        </div>
    );
};

export default OwnershipDetailsAccordion;
